import { ApolloLink } from "@apollo/client";

export interface RequestStartedContext {
  onRequestStarted?: () => void;
}

/** Observe network requests, excluding queries fulfilled entirely from Apollo's cache. */
export function createRequestStartedLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const context: RequestStartedContext = operation.getContext();
    context.onRequestStarted?.();
    return forward(operation);
  });
}
